import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {Tooltip} from 'primeng/tooltip';

@Component({
  selector: 'app-result-score-bar',
  imports: [Tooltip],
  templateUrl: './result-score-bar.component.html',
  styleUrls: ['./result-score-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultScoreBarComponent {
  private readonly segmentColors = {
    rfi: '#5679f6',
    rfp: '#8fa6ff',
    rfd: '#b25fd7',
  };

  readonly rfiWeightedPercent = input(0);
  readonly rfpWeightedPercent = input(0);
  readonly rfdWeightedPercent = input(0);
  readonly tooltipText = input('');

  readonly tooltipOptions = {
    escape: false,
    styleClass: 'result-score-tooltip',
  };

  readonly rfiWidth = computed(() => this.normalizePercentRange(this.rfiWeightedPercent()));
  readonly rfpWidth = computed(() => this.normalizePercentRange(this.rfpWeightedPercent()));
  readonly rfdWidth = computed(() => this.normalizePercentRange(this.rfdWeightedPercent()));
  readonly remainderWidth = computed(() => {
    const rfi = this.rfiWidth();
    const rfp = this.rfpWidth();
    const rfd = this.rfdWidth();
    return Math.max(0, 100 - rfi - rfp - rfd);
  });

  private normalizePercentRange(value: number): number {
    if (Number.isNaN(value) || value < 0) {
      return 0;
    }
    return value > 100 ? 100 : value;
  }

  protected get rfiColor(): string {
    return this.segmentColors.rfi;
  }

  protected get rfpColor(): string {
    return this.segmentColors.rfp;
  }

  protected get rfdColor(): string {
    return this.segmentColors.rfd;
  }
}
